module.exports = __webpack_public_path__ + "static/media/superman-hited.dd9a0616.png";